import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import MobileStepper from '@mui/material/MobileStepper';
import { Box, IconButton, Stack, Tooltip, useTheme } from '@mui/material';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { useState } from 'react';
import { motion } from 'framer-motion';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

export const ProductBanner = ({images}) => {

    const theme=useTheme()

    const [activeStep, setActiveStep] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    const maxSteps = images.length;

    const handleStepChange = (step) => {
        setActiveStep(step);
    };

  return (
    <>
    <Stack sx={{width:'100%',height:'100%'}}>
        <Box sx={{flex:1, minHeight:0, position:'relative'}}>
            <AutoPlaySwipeableViews
                style={{overflow:'hidden', height:'100%'}}
                width={'100%'}
                height={'100%'}
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={activeStep}
                onChangeIndex={handleStepChange}
                autoplay={!isPaused}
                enableMouseEvents
            >
                {images.map((image,index) => (
                    <Box key={index} sx={{width:'100%',height:'100%',display:'flex',alignItems:'stretch'}}>
                        {Math.abs(activeStep - index) <= 2 ? (
                            <Box
                                component={motion.img}
                                src={image}
                                alt={'Banner Image'}
                                initial={{ opacity: 0, scale: 0.985 }}
                                animate={{
                                    opacity: activeStep === index ? 1 : 0.7,
                                    scale: activeStep === index ? 1 : 0.985,
                                }}
                                transition={{ duration: 0.45, ease: 'easeOut' }}
                                sx={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain',
                                    objectPosition: 'center',
                                    display: 'block',
                                }}
                            />
                        ) : null}
                    </Box>
                ))}
            </AutoPlaySwipeableViews>
            <Tooltip title={isPaused ? 'Play banner' : 'Pause banner'}>
                <IconButton
                    onClick={() => setIsPaused((value) => !value)}
                    sx={{
                        position: 'absolute',
                        right: { xs: 12, md: 24 },
                        bottom: { xs: 12, md: 20 },
                        bgcolor: 'rgba(0,0,0,.72)',
                        color: 'white',
                        '&:hover': {
                            bgcolor: 'rgba(0,0,0,.88)',
                        },
                    }}
                    aria-label={isPaused ? 'Play banner' : 'Pause banner'}
                >
                    {isPaused ? <PlayArrowIcon /> : <PauseIcon />}
                </IconButton>
            </Tooltip>
        </Box>
        <Box sx={{alignSelf:'center'}}>
            <MobileStepper steps={maxSteps} position="static" activeStep={activeStep}/>
        </Box>
    </Stack>
    </>
  )
}
